module.exports = __webpack_public_path__ + "img/AI.0c7adf19.png";